import _classCallCheck from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Node from './node';
import NodeType from './type';

var CommentNode = /*#__PURE__*/function (_Node) {
  _inherits(CommentNode, _Node);

  var _super = _createSuper(CommentNode);

  function CommentNode(rawText, parentNode, range) {
    var _this;

    _classCallCheck(this, CommentNode);

    _this = _super.call(this, parentNode, range);
    _this.rawText = rawText;
    /**
     * Node Type declaration.
     * @type {Number}
     */

    _this.nodeType = NodeType.COMMENT_NODE;
    return _this;
  }
  /**
   * Get unescaped text value of current node and its children.
   * @return {string} text content
   */


  _createClass(CommentNode, [{
    key: "text",
    get: function get() {
      return this.rawText;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "<!--".concat(this.rawText, "-->");
    }
  }]);

  return CommentNode;
}(Node);

export { CommentNode as default };